import type { FlightSchedule, ScheduleStatus } from '@/shared/types'
import { ANNUAL_PLANS } from './annual-plans'

const MONTH_LABEL: Record<number, string> = {
  1: 'Tháng 1', 2: 'Tháng 2', 3: 'Tháng 3', 4: 'Tháng 4',
  5: 'Tháng 5', 6: 'Tháng 6', 7: 'Tháng 7', 8: 'Tháng 8',
  9: 'Tháng 9', 10: 'Tháng 10', 11: 'Tháng 11', 12: 'Tháng 12',
}

function pad(n: number): string {
  return String(n).padStart(2, '0')
}

function lastDayOfMonth(year: number, month: number): string {
  const d = new Date(year, month, 0)
  return `${year}-${pad(month)}-${pad(d.getDate())}`
}

function statusForMonth(year: number, month: number): ScheduleStatus {
  const today = new Date('2026-05-09')
  const startOfMonth = new Date(`${year}-${pad(month)}-01`)
  const endOfMonth = new Date(lastDayOfMonth(year, month))
  if (endOfMonth < today) return 'completed'
  if (startOfMonth <= today && today <= endOfMonth) return 'in-execution'
  if (month === today.getMonth() + 2) return 'pending-approval'
  if (month <= today.getMonth() + 3) return 'approved'
  return 'draft'
}

function generate(): FlightSchedule[] {
  const list: FlightSchedule[] = []
  ANNUAL_PLANS.filter((ap) => ap.status === 'in-execution' || ap.status === 'completed').forEach((ap) => {
    for (let m = 1; m <= 12; m++) {
      const status = statusForMonth(ap.year, m)
      const perMonthSorties = Math.round(ap.totalTargetSorties / 12)
      const perMonthHours = Math.round(ap.totalTargetHours / 12)
      const completionRate =
        status === 'completed' ? 0.9 + Math.random() * 0.1 :
        status === 'in-execution' ? 0.3 + Math.random() * 0.3 :
        0
      list.push({
        id: `fs-${ap.id}-${pad(m)}`,
        code: `KHB-${ap.year}-T${pad(m)}-${ap.id.split('-').slice(-1)[0]}`,
        annualPlanId: ap.id,
        unitId: ap.unitId,
        title: `Kế hoạch bay ${MONTH_LABEL[m]}/${ap.year}`,
        period: 'month',
        startDate: `${ap.year}-${pad(m)}-01`,
        endDate: lastDayOfMonth(ap.year, m),
        plannedSorties: perMonthSorties,
        actualSorties: Math.round(perMonthSorties * completionRate),
        plannedHours: perMonthHours,
        actualHours: Math.round(perMonthHours * completionRate),
        status,
        createdBy: 'Đại uý Nguyễn Hữu Nam',
        createdAt: `${ap.year - 1}-12-${pad(20 + (m % 9))}T08:00:00`,
        notes: m === 4 || m === 8 || m === 11 ? 'Có đợt tập trận liên hợp' : undefined,
      })
    }
  })
  return list
}

export const FLIGHT_SCHEDULES: FlightSchedule[] = generate()

export const FLIGHT_SCHEDULES_BY_ID: Record<string, FlightSchedule> = Object.fromEntries(
  FLIGHT_SCHEDULES.map((s) => [s.id, s]),
)

export const SCHEDULE_STATUS_LABEL: Record<ScheduleStatus, string> = {
  draft: 'Bản nháp',
  'pending-approval': 'Chờ duyệt',
  approved: 'Đã duyệt',
  'in-execution': 'Đang thực hiện',
  completed: 'Đã hoàn thành',
}

export const SCHEDULE_STATUS_COLOR: Record<ScheduleStatus, string> = {
  draft: 'default',
  'pending-approval': 'gold',
  approved: 'green',
  'in-execution': 'cyan',
  completed: 'success',
}
